import { h, Component, Host, Element, Prop, Event, EventEmitter } from "@stencil/core";
import pfx from "../../../../utils/style-class-prefix-helper";
import { BurgerPosition } from "./constants/navigation-main-types";
import {
  NAVIGATION_MAIN_BURGERPOSITION_LEFT,
  NAVIGATION_MAIN_BURGERPOSITION_RIGHT
} from "./constants/navigation-main-constants";
import { StyledComponent } from "../../../../decorators/styled-component";
// import { InitLogging } from "../../../../decorators/init-logging";

/**
 * @slot [unnamed] - holds up to three column components.
 */
@Component({
  tag: "eon-ui-navigation-main",
  styleUrl: "navigation-main.scss",
  shadow: true
})
export class NavigationMain {
  // @InitLogging() sentryTransaction;
  navigation: HTMLEonUiNavigationElement;

  @StyledComponent() component: any;
  @Element() hostElement: HTMLEonUiNavigationMainElement;

  /**
   * Defines the state of the burger.
   */
  @Prop({ mutable: true }) burgerActive: boolean = false;

  /**
   * Defines which navigation sections should stay visible when scrolling down.
   */
  @Prop() burgerPosition: BurgerPosition = NAVIGATION_MAIN_BURGERPOSITION_LEFT;

  /**
   * Whether the burger should be hidden.
   */
  @Prop() hideBurger: boolean = false;

  /**
   * Emits when burger menu is clicked.
   */
  @Event() burgerClick: EventEmitter<void>;

  componentWillLoad() {
    this.getRelatedComponents();
  }

  getRelatedComponents() {
    this.navigation = document.getElementById("eonui-navigation") as HTMLEonUiNavigationElement;
  }

  async handleBurgerClick(_event: Event) {
    this.burgerClick.emit();
    _event.preventDefault();

    if (this.burgerActive) {
      this.navigation.closeMobileNav();
    } else {
      await this.navigation.openMobileNav();
    }
  }

  private renderBurger() {
    if (this.hideBurger) return;

    return (
      <eon-ui-navigation-column>
        <button
          class={pfx({ "toggle-mobile-nav": true, active: this.burgerActive })}
          onClick={(event: MouseEvent) => this.handleBurgerClick(event)}
        >
          <span id="hamburger-icon">
            <span class="line line-1"></span>
            <span class="line line-2"></span>
            <span class="line line-3"></span>
          </span>
        </button>
      </eon-ui-navigation-column>
    );
  }

  render() {
    return (
      <Host>
        <nav
          aria-label="Navigation Main"
          class={pfx({
            "navigation-main-wrapper": true
          })}
        >
          <div class={pfx("navigation-main-inner")}>
            {this.burgerPosition === NAVIGATION_MAIN_BURGERPOSITION_LEFT && this.renderBurger()}
            <slot />
            {this.burgerPosition === NAVIGATION_MAIN_BURGERPOSITION_RIGHT && this.renderBurger()}
          </div>
        </nav>
      </Host>
    );
  }
}
